var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "c--shared_ekyc-detail ekyc-detail-wrapper"
  }, [_c('p', {
    staticClass: "ekyc-detail-title"
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('div', {
    staticClass: "ekyc-detail-card-and-learn-more overflow-hidden"
  }, [_c('div', {
    staticClass: "ekyc-detail-card"
  }, [_c('div', {
    staticClass: "d-flex align-items-center"
  }, [_c('i', {
    class: [_vm.kycDocumentNameAndIcon.icon, 'ekyc-detail-identity-card']
  }), _vm._v(" "), _c('p', {
    staticClass: "ekyc-detail-identity-card-title"
  }, [_vm._v("\n          " + _vm._s(_vm.kycDocumentNameAndIcon.text) + "\n        ")])]), _vm._v(" "), _c('p', {
    staticClass: "ekyc-detail-identity-name"
  }, [_vm._v("\n        " + _vm._s(_vm.identitiesDefault.full_name || '***** *****') + "\n      ")]), _vm._v(" "), _c('h1', {
    class: `ekyc-detail-verify-status ${_vm.verifyClass}`
  }, [_vm._v("\n        " + _vm._s(_vm.kycStatusText) + "\n      ")]), _vm._v(" "), !['rejected', 'pending'].includes(_vm.identitiesDefault.status) && this.identitiesDefault.expiry ? _c('p', {
    staticClass: "ekyc-detail-expires-date"
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.generateExpiryDate)
    }
  })]) : _vm._e(), _vm._v(" "), _vm.isShowLottie ? _c('div', [_c('Lottie', {
    ref: `ekyc-detail-identity-lottie`,
    staticClass: "player-item display-flex",
    style: `width: 60px; height: 17px;`,
    attrs: {
      "id": `ekyc-detail-identity-lottie`,
      "options": {
        loop: true,
        autoplay: true,
        animationData: _vm.identitiesDefault.status === 'rejected' ? _vm.rejectedLottie : _vm.verifyingLottie,
        rendererSettings: false
      },
      "width": 60,
      "height": 17
    }
  })], 1) : _vm._e(), _vm._v(" "), _vm.identitiesDefault.is_kyc_one_time ? _c('img', {
    staticClass: "ekyc-detail-card-operator-img",
    class: {
      topRight: _vm.identitiesDefault.is_kyc_one_time
    },
    attrs: {
      "width": "70",
      "height": "44",
      "src": _vm.identitiesDefault.packages.operator.image.url,
      "alt": "",
      "loading": "lazy"
    }
  }) : _vm._e(), _vm._v(" "), _c('i', {
    staticClass: "airalo-icon-exclamation-mark-round tw-text-white ekyc-detail-card-info",
    class: {
      topRightInfo: !_vm.identitiesDefault.is_kyc_one_time,
      bottomRight: _vm.identitiesDefault.is_kyc_one_time
    },
    attrs: {
      "id": "ekyc-detail-card-info"
    }
  }), _vm._v(" "), _c('Tooltip', {
    attrs: {
      "target": "ekyc-detail-card-info",
      "text": _vm.ekycDetailTooltipText(),
      "button-text": _vm.$t('components.tooltip.got-it-button'),
      "is-clone-target": true
    }
  }), _vm._v(" "), _c('a-icon', {
    staticClass: "ekyc-detail-finger-print",
    attrs: {
      "type": "image",
      "loader": "data",
      "name": "icon-ekyc-detail-finger-print"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "ekyc-detail-learn-more-right"
  }, [_vm.identitiesDefault.status === 'rejected' && _vm.identitiesDefault.rejection_reason_translated ? [_c('div', {
    staticClass: "ekyc-detail-learn-more-rejection"
  }, [_c('p', {
    staticClass: "ekyc-detail-learn-more-rejection-title"
  }, [_vm._v("\n            " + _vm._s(_vm.$t('scenes.identity.authentication.rejection-reason-title')) + "\n          ")]), _vm._v(" "), _c('p', {
    staticClass: "ekyc-detail-learn-more-rejection-desc"
  }, [_vm._v("\n            " + _vm._s(_vm.identitiesDefault.rejection_reason_translated) + "\n          ")])])] : _vm._e(), _vm._v(" "), _c('p', {
    staticClass: "ekyc-detail-learn-more-title"
  }, [_vm._v("\n        " + _vm._s(_vm.$t('scenes.identity.authentication.description-title.v2')) + "\n      ")]), _vm._v(" "), _c('i18n', {
    staticClass: "ekyc-detail-learn-more-description-subtitle tw-mb-0",
    attrs: {
      "path": "scenes.identity.authentication.description-subtitle.v2",
      "tag": "p"
    },
    scopedSlots: _vm._u([{
      key: "goToHelpCenter",
      fn: function () {
        return [_c('a', {
          attrs: {
            "href": _vm.$t('url.identity.authentication.help-center'),
            "target": "_blank",
            "rel": "noopener"
          }
        }, [_vm._v("\n            " + _vm._s(_vm.$t('scenes.identity.authentication.go-to-help-center.v2')) + "\n          ")])];
      },
      proxy: true
    }])
  })], 2)]), _vm._v(" "), [null, 'rejected', 'expired'].includes(_vm.identitiesDefault.status) ? _c('div', {
    staticClass: "ekyc-detail-verify-btn std-alone-sized-larger btn-primary-hv",
    attrs: {
      "data-testid": "eKYC-button"
    },
    on: {
      "click": function ($event) {
        return _vm.toCompleteKyc();
      }
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('global.ekyc-procced-resubmit')))]), _vm._v(" "), _c('KYCVerifyModal')], 1) : _vm._e()]);

}
var staticRenderFns = []

export { render, staticRenderFns }